import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

import { ButtonWrapper } from '../Button/Button.styles'

export const ModalBackdrop = styled.div`
  ${Cover()}
`

export const ModalIcon = styled.div`
  svg {
    display: block;
    height: 14rem;
    width: auto;
    fill: ${({ theme }) => theme.colors.global};
    margin-bottom: 3rem;

    .primary {
      fill: var(--color-primary);
    }
  }
`

export const ModalDialog = styled.div`
  position: absolute;
  top: calc(2rem + var(--size-top-bar));
  left: 2rem;
  right: 2rem;
  bottom: 6rem;
  box-shadow: 0px 4px 174px rgba(0, 20, 137, 0.2);
  padding: 4rem;
  background-color: var(--color-body);
  border-radius: 2rem;
  color: var(--color-global);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  bottom: 0;
  z-index: 150;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  overflow: auto;
`

export const ModalClose = styled.div`
  ${Reset('button')}
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  ${Reset('button')}
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--color-global);
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${TransitionPrimary('background-color', 'color')}

  &:hover {
    background-color: var(--color-global);
    color: var(--color-light);
  }

  svg {
    width: 1.5rem;
    fill: currentColor;
    display: block;
  }
`

export const ModalFooter = styled.div`
  padding-top: 1.75rem;
`
